/**
 * Clamps a number between the given min and max (both inclusive).
 * @param value The value to be clamped.
 * @param min The minimum value to be clamped to.
 * @param max The maximum value to be clamped to.
 * @returns
 */
export function clamp(value: number, min: number, max?: number) {
  if (value < min) return min;

  if (max !== undefined && value > max) return max;

  return value;
}
